/**
 * Composition method for EPIC HR sections
 * 
 * Author: Andrea López
 */
 import { computed, watch } from 'vue';
 import { useStore } from 'vuex';

export function epicSectionsComposition (data: any) {
    const store = useStore();

    // Computed active section
	const activeSection = computed((): string => store.getters.get_ehrActiveSection);
	const activeFrame = computed((): string => store.getters.get_ehrActiveFrame);

    // function activate to section
    function switchSection (sectionTo: string) {
        store.dispatch('axn_updateEhrActiveSection', sectionTo);
    }

    // function activate to frame
    function switchFrame (frameTo: string) {
        store.dispatch('axn_updateEhrActiveFrame', frameTo);
    }

    function activateFrameBySection () {
        const firstFrame = data.value.filter((_: any) => _.section === activeSection.value)[0];

        switchFrame(firstFrame.endpointId);
    }
    
    function activateSectionByFrame () {
        const frameData = data.value.find((_: any) => _.endpointId === activeFrame.value);

        switchSection(frameData.section);
    }

    watch(activeSection, () => {
        activateFrameBySection();
    })
    
    watch(activeFrame, () => {
        activateSectionByFrame();
    })

    // Active frames by section active
    const activeFrames = computed((): any[] => data.value.filter((_: any) => _.section === activeSection.value))

    return {
        activeSection, activeFrame, switchSection,
        switchFrame, activeFrames
    }
}